import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Customer_api } from "../../../Apiconfig";
import style from "../customer list/Customerlist.module.css";
import AddCustomerForm from '../add customer global/Addcustomer';

export default function Customerlist() {
  const [activeCustomer, setActiveCustomer] = useState(null); // To track selected customer
  const [activeTab, setActiveTab] = useState("profile"); // Default view is 'profile'
  const [customers, setCustomers] = useState([]); // Customer list state
  const fetched = useRef(false); // ref to track if the data has already been fetched

  const [isEditing, setIsEditing] = useState(false);
  const [editedCustomer, setEditedCustomer] = useState({ ...activeCustomer });
  const [error, setError] = useState("");

  const [hasMore, setHasMore] = useState(true); // Default: true
  const [hasCustomerMore, setHasCustomerMore] = useState(true); // Default: true
  const [hasTransactionMore, setHasTransactionMore] = useState(true); // Default: true
  const [hasOrderMore, setHasOrderMore] = useState(true); // Default: true

  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false); // To prevent multiple fetches
  const [currentPage, setCurrentPage] = useState(0);


  const [searchResults, setSearchResults] = useState([]); // Search results data
  const [searchQuery, setSearchQuery] = useState(""); // Track the search query


  const [searchResultsoid, setSearchResultsoid] = useState([]); // Search results data
  const [searchQueryoid, setSearchQueryoid] = useState(""); // Track the search query


  const [isSwitching, setIsSwitching] = useState(false);  // Flag to track switching


  // const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All Data");

  const [selectedTransectionCategory, setSelectedTransectionCategory] = useState("All Data");


  // useEffect(() => {
  //   fetchCustomersorderhis(page, selectedCategory); // Fetch inventory with category filter
  // }, [page, selectedCategory]); // Dependency array includes selectedCategory

  // const filterOrders = async () => {
  //   try {
  //     const response = await axios.get(`${Customer_api}/filterOrders.php`, {
  //       params: { filter: selectedCategory, customer_id: activeCustomer.id },
  //       withCredentials: true,
  //     });

  //     if (response.data.success) {
  //       console.log(response);
  //       console.log(response.data);
  //     } else {
  //       console.log("ERROR: " + response.data.message);
  //     }

  //   } catch (err) {
  //     console.error("Failed to fetch categories", err);
  //   }
  // };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setPage(1);  // Reset to page 1
    setCustomersorderhis([]);
    setHasOrderMore(true);
    // filterOrders();
  };

  const handleTransectionCategoryChange = (e) => {
    setSelectedTransectionCategory(e.target.value);
    setPage(1);  // Reset to page 1
    setCustomerstransaction([]);
    setHasTransactionMore(true);
    // filterOrders();
  };


  // This function is called when switching to another customer or tab
  const handleSwitchCustomer = () => {
    setSelectedCategory("All Data");
    setSelectedTransectionCategory("All Data");
    setIsSwitching(true);
  };


  const [customersorderhis, setCustomersorderhis] = useState([]); // Customer order history list state

  const fetchCustomersorderhis = async (pageNumber) => {
    if (loading || !hasOrderMore) return; // Prevent duplicate calls

    setLoading(true);
    setCurrentPage(pageNumber); // Update current page being fetched

    try {
      const response = await axios.get(
        `${Customer_api}Show_customer_order_history.php?customer_id=${activeCustomer.id}`,
        {
          params: { page: pageNumber, filter: selectedCategory },
          withCredentials: true,
        }
      );

      if (response.data && response.data.length > 0) {
        setCustomersorderhis((prevData) => [...prevData, ...response.data]);
        console.log(response.data);
        console.log(customersorderhis);
      } else {
        setHasOrderMore(false); // No more data
      }

      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Order History data");
      setLoading(false);
    }
  };




  useEffect(() => {
    setHasMore(true); // Reset to true to allow fetching in the new tab
    setLoading(false); // Reset loading state
    setPage(1); // Start from the first page of the new tab's data


    if (!fetched.current) {  // Check if the data has been fetched before
      if (customers.length === 0) {
        fetched.current = true; // Mark as fetched before triggering the API
        setPage(1);
        fetchCustomers(1); // Fetch customers on mount
        // fetched.current = true; // Mark as fetched
      }
    } else if (activeTab === "order_history") {
      if (customersorderhis.length === 0) {
        setPage(1); // Start from the first page for Order History
        fetchCustomersorderhis(1); // Fetch the first page of data for Order History
        handleSwitchCustomer();
      }
    } else if (activeTab === "ordered_items") {
      if (customerproductlist.length === 0) {
        setPage(1); // Start from the first page for Ordered Items
        fetchCustomerproductlist(1); // Fetch the first page of data for Ordered Items
        handleSwitchCustomer();
      }
    } else if (activeTab === "transactions") {
      if (customerstransaction.length === 0) {
        setPage(1); // Start from the first page for Transactions
        fetchCustomerstransaction(1); // Fetch the first page of data for Transactions
        handleSwitchCustomer();
      }
    }
  }, [activeTab]); // Only trigger when `activeTab` changes



  const fetchCustomers = async (pageNumber) => {
    if (loading || !hasMore) return; // Prevent duplicate calls

    setLoading(true);
    setCurrentPage(pageNumber);

    try {
      const response = await axios.get(`${Customer_api}Show_customer.php`, {
        params: { page: pageNumber },
        withCredentials: true,
      });

      if (response.data.customers && response.data.customers.length > 0) {
        setCustomers((prevData) => [...prevData, ...response.data.customers]);
      } else {
        setHasMore(false); // No more data
      }
    } catch (error) {
      setError("Error fetching customers:");
    } finally {
      setLoading(false);
    }
  };




  // Search inventory data
  const handleSearch = async (query) => {
    setSearchQuery(query);
    if (query.trim().length < 3) {
      setSearchResults([]); // Clear search results if query is empty
      return;
    }

    try {
      const response = await axios.get(`${Customer_api}/SearchListCustomer.php`, {
        params: { search: query },
        withCredentials: true,
      });

      if (response.data && response.data.products) {
        setSearchResults(response.data.products);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.error("Failed to fetch search results:", err);
    }
  };


  const handleSearchOHByOrderId = async (query) => {
    setSearchQueryoid(query);

    try {
      const response = await axios.get(`${Customer_api}/O_H_by_O_ID.php`, {
        params: { search: query, customer_id: activeCustomer.id },
        withCredentials: true,
      });

      if (response.data && response.data.products) {
        setSearchResultsoid(response.data.products);
      } else {
        setSearchResultsoid([]);
      }
    } catch (err) {
      console.error("Failed to fetch order search results:", err);
    }
  };







  const handleSearchOItemByOrderId = async (query) => {
    setSearchQueryoid(query);

    try {
      const response = await axios.get(`${Customer_api}/O_Item_by_O_ID.php`, {
        params: { search: query, customer_id: activeCustomer.id },
        withCredentials: true,
      });

      if (response.data && response.data.products) {
        setSearchResultsoid(response.data.products);
      } else {
        setSearchResultsoid([]);
      }
    } catch (err) {
      console.error("Failed to fetch order search results:", err);
    }
  };





  const handleSearchTransactionByOrderId = async (query) => {
    setSearchQueryoid(query);

    try {
      const response = await axios.get(`${Customer_api}/OT_by_O_ID_And_T_ID.php`, {
        params: { search: query, customer_id: activeCustomer.id },
        withCredentials: true,
      });

      if (response.data && response.data.products) {
        setSearchResultsoid(response.data.products);
      } else {
        setSearchResultsoid([]);
      }
    } catch (err) {
      console.error("Failed to fetch order search results:", err);
    }
  };



  // Handle input changes and update the state
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCustomer((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file input changes (Aadhar image upload)
  const handleFileChange = (e) => {
    setEditedCustomer((prev) => ({
      ...prev,
      aadhar_image: e.target.files[0], // Store the file object in state
    }));
  };



  // Save changes to the database
  const saveChanges = async () => {
    try {
      const response = await axios.post(
        `${Customer_api}Update_customer.php`,
        editedCustomer,
        {
          withCredentials: true,
        }
      );
      console.log(editedCustomer);
      console.log(response.data);

      if (response.data.success) {
        alert("Customer updated successfully!");
        setIsEditing(false); // Exit edit mode
      } else {
        setError(response.data.error || "Failed to update customer.");
      }
    } catch (error) {
      console.error("Error updating customer:", error);
      setError("An error occurred while updating the customer.");
    }
  };

  // Cancel changes and revert to the original customer data
  const cancelChanges = () => {
    setEditedCustomer({ ...activeCustomer }); // Revert to original values
    setIsEditing(false); // Exit edit mode
  };


  const [customerproductlist, setCustomerproductlist] = useState([]); // Customer order history list state

  const fetchCustomerproductlist = async (pageNumber) => {
    if (loading || !hasCustomerMore) return; // Prevent duplicate calls

    setLoading(true);
    setCurrentPage(pageNumber); // Update current page being fetched

    try {
      const response = await axios.get(
        `${Customer_api}Show_customer_productlist.php?customer_id=${activeCustomer.id}`,
        {
          params: { page: pageNumber },
          withCredentials: true,
        }
      );

      if (response.data && response.data.length > 0) {
        setCustomerproductlist((prevData) => [...prevData, ...response.data]); 
      } else {
        setHasCustomerMore(false); // No more data
      }

      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Product List data");
      setLoading(false);
    }


  };



  const [customerstransaction, setCustomerstransaction] = useState([]); // Customer transaction history list state


  const fetchCustomerstransaction = async (pageNumber) => {
    if (loading || !hasTransactionMore) return; // Prevent duplicate calls

    setLoading(true);
    setCurrentPage(pageNumber); // Update current page being fetched

    try {
      const response = await axios.get(
        `${Customer_api}Show_customer_transaction.php?customer_id=${activeCustomer.id}`,
        {
          params: { page: pageNumber, filter: selectedTransectionCategory },
          withCredentials: true,
        }
      );


      if (response.data && response.data.length > 0) {
        setCustomerstransaction((prevData) => [...prevData, ...response.data]);
        console.log(response.data);
        console.log(customerstransaction);
      } else {
        setHasTransactionMore(false); // No more data
      }

      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Transection data");
      setLoading(false);
    }


  };



  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debouncedHandleScroll = debounce((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 5 && !loading) {
      if (activeTab === "order_history") {
        // Call the function for Order History
        fetchCustomersorderhis(page + 1); // Fetch the next page for order history
        setPage((prevPage) => prevPage + 1); // Increment the page number
      } else if (activeTab === "ordered_items") {
        // Call the function for Ordered Items
        fetchCustomerproductlist(page + 1); // Fetch the next page for ordered items
        setPage((prevPage) => prevPage + 1); // Increment the page number
      } else if (activeTab === "transactions") {
        // Call the function for transactions
        fetchCustomerstransaction(page + 1); // Fetch the next page for transactions
        setPage((prevPage) => prevPage + 1); // Increment the page number
      } else {
        // Always fetch customers
        fetchCustomers(page + 1); // Fetch the next page for customers
        setPage((prevPage) => prevPage + 1); // Increment the page number
      }
    }
  }, 200);






  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const [orderDetails, setOrderDetails] = useState([]);

  useEffect(() => {
    if (isModalOpen && selectedOrderId) {
      fetch(`${Customer_api}Fetch_p_list_Acc_OrderID.php?order_id=${selectedOrderId}`, {
        method: "GET",
        credentials: "include", // Ensures cookies or session data are sent with the request
      })
        .then((response) => response.json())
        .then((data) => {
          setOrderDetails(data); // Store fetched data
        })
        .catch((error) => {
          console.error("Error fetching order details:", error);
        });
    }
  }, [isModalOpen, selectedOrderId]);




  return (
    <div className={style.customerlistpanel}>

      {/* Customer List or Details View */}
      {!activeCustomer ? (
        <div className={style.customerTableContainer}>
          <div className={` ${style.dataseacrhrow} row`}>
            <div className={` ${style.customersearchfieldcol} col-md-8`}>

              <div className="col-md-4 text-center">
                <h2 className={style.title}>Customer Management</h2>
              </div>

              <div className={style.customersearchsideleft}>

                <input
                  type="text"
                  placeholder="SEARCH BY NAME"
                  className={style.customersearchfield}
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                {/* &nbsp; */}

                {/* add cuatomer button */}
                <AddCustomerForm />
              </div>
            </div>

          </div>

          {/* list start here */}

          <p className={style.commentmsg}>CLICK ON CUSTOMER TO SEE DETAILS</p>
          <div
            className={`${style.scrollableTablecustomerlist} table-responsive`}
            onScroll={debouncedHandleScroll} // Use the external function here
            style={{ height: '60vh', overflowY: 'auto' }}
          >
            <table className={style.customerTable}>
              <thead>
                <tr className={style.customertablehead_tr}>
                  <th>Name</th>
                  <th>Customer id</th>
                  <th>Contact</th>
                  <th>Adhar</th>
                  <th>City</th>
                </tr>
              </thead>
              <tbody>
                {customers.length > 0 ? (
                  (searchQuery ? searchResults : customers).map((customer) => (
                    <tr
                      key={customer.id}
                      onClick={() => {
                        setActiveCustomer(customer);
                        // Directly update editedCustomer with the correct `id`
                        setEditedCustomer({
                          ...customer, // Use the customer object itself
                          id: customer.id, // Ensure the id is included
                        });
                        setActiveTab("profile"); // Redirect to the Profile tab
                      }}
                    >
                      <td>{customer.customer_name}</td>
                      <td>{customer.id}</td>
                      <td>{customer.contact}</td>
                      <td>{customer.aadhar}</td>
                      <td>{customer.city}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No customer found</td>
                  </tr>
                )}
              </tbody>
            </table>
            {customers.length === 0 && <p>Loading...</p>}
          </div>
        </div>
      ) : (


        <div className={`container-fluid ${style.customerDetailContainer}`}>
          <div className="row justify-content-center align-items-start">


            {/* Left Side Buttons */}


            <div className="col text-center">
              {/* Go back button */}
              <button
                className={style.goBackButton}
                onClick={() => {
                  setActiveCustomer(null);
                  setCustomersorderhis([]);
                  setCustomerproductlist([]);
                  setCustomerstransaction([]);
                  setHasCustomerMore(true);
                  setHasTransactionMore(true);
                  setHasOrderMore(true);
                  setHasMore(true);
                  setActiveTab("profile");
                  handleSwitchCustomer();
                }}
              >
                <i className="fa-solid fa-arrow-left"></i> Go Back
              </button>


              <div className={style.customerData}>
                <h4>Name: {activeCustomer.customer_name}</h4>
                <h4>Contact: {activeCustomer.contact}</h4>
                {/* <h4>Customer ID : {activeCustomer.id}</h4> */}
              </div>

              <div className={style.buttonGroup}>
                {/* Dropdown for mobile */}
                <select
                  className={style.dropdown}
                  onChange={(e) => {
                    setActiveTab(e.target.value);
                    if (e.target.value === "order_history") { fetchCustomersorderhis(); setCustomersorderhis([]); }
                    else if (e.target.value === "ordered_items") { fetchCustomerproductlist(); setCustomerproductlist([]); }
                    else if (e.target.value === "transactions") { fetchCustomerstransaction(); setCustomerstransaction([]); }
                  }}
                >
                  <option value="profile">Profile</option>
                  <option value="order_history">Order History</option>
                  <option value="ordered_items">Ordered Items</option>   
                  <option value="transactions">Transactions</option>
                </select>

                {/* Buttons for larger screens */}
                <div className={style.desktopButtons}>
                  <button
                    className={style.actionButton}
                    onClick={() => setActiveTab("profile")}
                  >
                    Profile
                  </button>

                  <button
                    className={style.actionButton}
                    onClick={() => {
                      setActiveTab("order_history");
                      setCustomersorderhis([]);
                      fetchCustomersorderhis();
                    }}
                  >
                    Order History
                  </button>
                  <button
                    className={style.actionButton}
                    onClick={() => {
                      setActiveTab("ordered_items");
                      setCustomerproductlist([]);
                      fetchCustomerproductlist();
                    }}
                  >
                    Ordered Items
                  </button>
                  <button
                    className={style.actionButton}
                    onClick={() => {
                      setActiveTab("transactions");
                      setCustomerstransaction([]);
                      fetchCustomerstransaction();
                    }}
                  >
                    Transactions
                  </button>
                </div>
              </div>
            </div>





            {/* Right Side Content */}

            <div className="col-md-9">

              {activeTab === "profile" && (
                <div className="col-md-9">

                  <div className="col-12 col-md-4 mb-2 mb-md-0">
                    <h5 className="fw-bold text-dark">Customer Profile:</h5>
                  </div>


                  {isEditing ? (
                    <div className={style.editProfile}>
                      <div className="row">
                        <div className="col-12 mb-3">
                          <label>Name:</label>
                          <input
                            type="text"
                            name="customer_name"
                            value={editedCustomer.customer_name}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <label>Contact:</label>
                          <input
                            type="text"
                            name="contact"
                            value={editedCustomer.contact}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <label>Aadhar:</label>
                          <input
                            type="text"
                            name="aadhar"
                            value={editedCustomer.aadhar}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <label>City:</label>
                          <input
                            type="text"
                            name="city"
                            value={editedCustomer.city}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <label>Pincode:</label>
                          <input
                            type="text"
                            name="pincode"
                            value={editedCustomer.pincode}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="col-12 mb-3">
                          <label>Address:</label>
                          <input
                            type="text"
                            name="customer_address"
                            value={editedCustomer.customer_address}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="col-12 mt-3">
                          <button onClick={cancelChanges} className={style.editbutton}>Cancel</button> &nbsp;
                          <button onClick={saveChanges} className={style.editbutton}>Save Changes</button>
                        </div>
                      </div>
                    </div>
                  ) : (


                    <div className={`profile-section ${style.editProfileSection}`}>
                      <div className="row">

                        <p><strong>Name:</strong> {activeCustomer.customer_name}</p>
                        <p><strong>Contact:</strong> {activeCustomer.contact}</p>
                        <p><strong>Aadhar:</strong> {activeCustomer.aadhar}</p>
                        <p><strong>City:</strong> {activeCustomer.city}</p>
                        <p><strong>Pincode:</strong> {activeCustomer.pincode}</p>
                        <p><strong>Address:</strong> {activeCustomer.customer_address}</p>
                        <div className="col-12">
                          <button onClick={() => setIsEditing(true)} className={style.editbutton}>
                            Edit Profile
                          </button>
                        </div>
                      </div>
                    </div>


                  )}
                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
              )}




              {activeTab === "order_history" && (

                <div>
                  <div className="row align-items-center mb-4">
                    <div className="col-12 col-md-3 mb-2 mb-md-0">
                      <h5 className="fw-bold text-dark">Order History:</h5>
                    </div>

                    <div className="col-12 col-md-4 mb-2 mb-md-0">
                      <input
                        type="text"
                        placeholder="Search by Order ID"
                        className="form-control rounded-pill shadow-sm"
                        value={searchQueryoid}
                        onChange={(e) => handleSearchOHByOrderId(e.target.value)}
                      />
                    </div>

                    <div className="col-12 col-md-4">
                      <select
                        className="form-select rounded-pill border-light shadow-sm"
                        value={selectedCategory}
                        onInput={handleCategoryChange}
                        onChange={fetchCustomersorderhis}
                      >
                        <option value="All Data">All Data</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Pending">Pending</option>
                        <option value="Canceled">Canceled</option>
                      </select>
                    </div>
                  </div>

                  <p className={style.commentmsg}>CLICK ON ORDER ID TO SEE DETAILED PRODUCT LIST FOR SPECIFIC ORDER ID</p>
                  <div
                    className={`${style.scrollableTable} ${style.orderHistoryTable}`}
                    onScroll={debouncedHandleScroll} // Use the external function here
                    style={{ height: '280px', overflowY: 'auto' }}
                  >
                    <table className={`table table-striped `}>
                      <thead>
                        <tr className={style.customertablehead_tr}>
                          <th>order_id</th>
                          <th>Customer_id</th>
                          <th>total_amoun</th>
                          <th>order_status</th>
                          <th>paid_amount</th>
                          <th>dues</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customersorderhis.length > 0 ? (
                          (searchQueryoid ? searchResultsoid : customersorderhis).map((customerodrhis) => (
                            <tr
                              key={customerodrhis.customer_id}
                              onClick={() => {
                                setIsModalOpen(true);
                                setSelectedOrderId(customerodrhis.id);
                              }}
                            >
                              {/* <td>{customerodrhis.id}</td> */}
                              <td >
                                {customerodrhis.id}
                              </td>

                              <td>{customerodrhis.customer_id}</td>
                              <td>{customerodrhis.total_amount}</td>
                              <td>{customerodrhis.order_status}</td>
                              <td>{customerodrhis.paid_amount}</td>
                              <td>{customerodrhis.due_amount}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4">No Order found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {customersorderhis.length === 0 && <p>Loading...</p>}
                  </div>
                </div>
              )}


              {activeTab === "ordered_items" && (
                <div>

                  <div className="row align-items-center mb-4">
                    <div className="col-md-3">
                      <h5 className="fw-bold text-dark">Order Items:</h5>
                    </div>

                    <div className="col-md-4">

                      <input
                        type="text"
                        placeholder="Search by Order ID"
                        className="form-control rounded-pill shadow-sm"
                        value={searchQueryoid}
                        onChange={(e) => handleSearchOItemByOrderId(e.target.value)}
                      />
                    </div>

                    <div className="col-md-3">

                      {/* <select
                        className="form-select rounded-pill border-light shadow-sm"
                      value={selectedCategory}
                      onInput={handleCategoryChange} // Handles the value change
                      onChange={fetchCustomersorderhis} // Handles the value change
                      >
                        <option value="All Data">All Data</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Pending">Pending</option>
                        <option value="Canceled">Canceled</option>
                      </select> */}

                    </div>
                  </div>

                  <div
                    className={`${style.scrollableTable} ${style.orderHistoryTable}`}
                    onScroll={debouncedHandleScroll}
                    style={{ height: '280px', overflowY: 'auto' }}
                  >

                    <table className={`table table-striped ${style.table}`}>
                      <thead>
                        <tr className={style.customertablehead_tr}>
                          <th>id</th>
                          <th>Customer id</th>
                          <th>order id</th>
                          <th>product_name</th>
                          <th>product_quantity</th>
                          <th>unit_price</th>
                          <th>Total price</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerproductlist.length > 0 ? (
                          (searchQueryoid ? searchResultsoid : customerproductlist).map((customerproduct) => (
                            <tr
                              key={customerproduct.id}
                            >
                              <td>{customerproduct.id}</td>
                              <td>{customerproduct.customer_id}</td>
                              <td>{customerproduct.order_id}</td>
                              <td>{customerproduct.product_name}</td>
                              <td>{customerproduct.product_quantity}</td>
                              <td>{customerproduct.unit_price}</td>
                              <td>{customerproduct.total_price}</td>
                              <td>{customerproduct.status}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4">No Product found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {customerproductlist.length === 0 && <p>Loading...</p>}
                  </div>
                </div>
              )}


              {activeTab === "transactions" && (
                <div>

                  <div className="row align-items-center mb-4">
                    <div className="col-md-3">
                      <h5 className="fw-bold text-dark">Transactions:</h5>
                    </div>

                    <div className="col-md-4">
                      <input
                        type="text"
                        placeholder="Search by Order ID"
                        className="form-control rounded-pill shadow-sm"
                        value={searchQueryoid}
                        onChange={(e) => handleSearchTransactionByOrderId(e.target.value)}
                      />
                    </div>

                    <div className="col-md-4">
                      <select
                        className="form-select rounded-pill border-light shadow-sm"
                        value={selectedTransectionCategory}
                        onInput={handleTransectionCategoryChange} // Handles the value change
                        onChange={fetchCustomerstransaction} // Handles the value change
                      >
                        <option value="All Data">All Data</option>
                        <option value="CASH">CASH</option>
                        <option value="UPI">UPI</option>
                      </select>

                    </div>
                  </div>

                  <div
                    className={`${style.scrollableTable} ${style.orderHistoryTable}`}
                    onScroll={debouncedHandleScroll} // Use the external function here
                    style={{ height: '280px', overflowY: 'auto' }}
                  >

                    <table className={`table table-striped ${style.table}`}>
                      <thead>
                        <tr className={style.customertablehead_tr}>
                          <th>Customer id</th>
                          <th>Order id</th>
                          <th>transaction id</th>
                          <th>total amount</th>
                          <th>pay method</th>
                          <th>transaction type</th>
                          <th>transaction status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerstransaction.length > 0 ? (
                          (searchQueryoid ? searchResultsoid : customerstransaction).map((customertran) => (
                            <tr
                              key={customertran.customer_id}

                            >
                              <td>{customertran.customer_id}</td>
                              <td>{customertran.order_id}</td>
                              <td>{customertran.transaction_id}</td>
                              <td>{customertran.total_amount}</td>
                              <td>{customertran.payment_method}</td>
                              <td>{customertran.transaction_type}</td>
                              <td>{customertran.transaction_status}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4">No Transaction found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {customerstransaction.length === 0 && <p>Loading...</p>}
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>

      )}


      {isModalOpen && (
        <div className={style.modalOverlay}>
          <div className={style.customModal}>
            <div className="row">
              <div className="col text-start">
                <h3>Order Details</h3>
              </div>
              <div className="col text-end">
                <button
                  className={style.closeButton}
                  onClick={() => setIsModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>

            <p>Order ID: {selectedOrderId}</p>
            <div className="row">
              <div
                className={`${style.scrollableTable} ${style.orderHistoryTable}`}
                onScroll={debouncedHandleScroll}
                style={{ height: '280px', overflowY: 'auto' }}
              >
                <table className={`table table-striped ${style.table}`}>
                  <thead>
                    <tr className={style.customertablehead_tr}>
                      <th>id</th>
                      <th>Customer id</th>
                      <th>order id</th>
                      <th>product_name</th>
                      <th>product_quantity</th>
                      <th>unit_price</th>
                      <th>Total price</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails.length > 0 ? (
                      orderDetails.map((detail, index) => (
                        <tr key={index}>
                          <td>{detail.id}</td>
                          <td>{detail.customer_id}</td>
                          <td>{detail.order_id}</td>
                          <td>{detail.product_name}</td>
                          <td>{detail.product_quantity}</td>
                          <td>{detail.unit_price}</td>
                          <td>{detail.total_price}</td>
                          <td>{detail.status}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8">No details found for this order</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}



      {/* {hasMore ? (
        <p></p>
      ) : (
        <div className={style.hasmorrow}>
          <p className={style.nomoredata}>No more data to display all the data is here already.</p>
        </div>
      )} */}


    </div>
  );
}

